var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArFunctionMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "24,20.3818359 17.4472656,17.1054688 16.5527344,18.8945312 23,22.1181641 23,28.5 25,28.5 25,22.1181641  31.4472656,18.8945312 30.5527344,17.1054688  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3417969,43.6835938c-0.1095581,0.0548706-0.227478,0.0827637-0.3417969,0.12323V36.5h-2v7.3061523 c-0.1156616-0.0408325-0.2347412-0.0692139-0.3457031-0.1245117l-5.2109375-2.578125l-0.8867188,1.7929688l5.2070312,2.5761719 c0.7011719,0.3496094,1.46875,0.5244141,2.2373047,0.5244141c0.7666016,0,1.5341797-0.1738281,2.2314453-0.5224609 l5.2109375-2.578125l-0.8867188-1.7929688L25.3417969,43.6835938z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5527344,31.6054688L6,34.3818359V28H4v6.7636719c0,1.1435547,0.6357422,2.171875,1.6582031,2.6835938 l5.8945312,2.9472656l0.8945312-1.7890625L7.2363281,36l5.2109375-2.6054688L11.5527344,31.6054688z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,34.3818359l-5.5527344-2.7763672l-0.8945312,1.7890625L40.7636719,36l-5.2109375,2.6054688l0.8945312,1.7890625 l5.8945312-2.9472656C43.3642578,36.9355469,44,35.9072266,44,34.7636719V28h-2V34.3818359z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5498047,7.6074219l-5.8916016,2.9726562C4.6357422,11.0917969,4,12.1201172,4,13.2636719V20h2v-6.3818359 l5.5527344,2.7763672l0.8945312-1.7890625l-5.1873779-2.593689l5.1903076-2.6192017L11.5498047,7.6074219z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6582031,4.3164062C22.7677612,4.2615967,22.8856812,4.2336426,23,4.1931763V11.5h2V4.1937866 c0.1156616,0.0408325,0.2347412,0.0692749,0.3457031,0.1245728l5.2109375,2.578125l0.8867188-1.7929688l-5.2070312-2.5761719 c-1.4013672-0.6992188-3.0732422-0.7011719-4.46875-0.0019531l-5.2109375,2.578125l0.8867188,1.7929688L22.6582031,4.3164062z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3447266,10.5820312l-5.8945312-2.9746094l-0.9003906,1.7851562l5.1898804,2.6194458l-5.1869507,2.5934448 l0.8945312,1.7890625L42,13.6181641V20h2v-6.7363281C44,12.1201172,43.3642578,11.0917969,42.3447266,10.5820312z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArFunctionMedium);
export default __webpack_public_path__ + "static/media/ar-function--medium.8bb437d6bf246c9a54bb6acdd14c67f5.svg";
export { ForwardRef as ReactComponent };